import EventBus from "./event-bus";
import {errorHandler} from "./utils";

const axios = require('axios');

export function wmsSearchProducts(searchWord) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/products/all/search?words=' + searchWord, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {

      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        // EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function getWmsCategories() {
  return new Promise(function(resolve, reject) {
    // console.log("getCategories " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'wms/categories', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsProductInventories(pId) {
  return new Promise(function(resolve, reject) {
    // console.log("get inventory list");
    axios.get(process.env.ROOT_API + 'wms/product/' + pId + '/inventories', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsDeliveryOrderItems(categoryId, deliveryDate) {
  return new Promise(function(resolve, reject) {
    // console.log("get inventory list");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/orders/category/' + categoryId +'?deliveryDate=' + deliveryDate, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsOrders(deliveryDate, driverId, listOnly) {
  return new Promise(function(resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/orders?deliveryDate=' + deliveryDate + '&driverId=' + driverId + '&listOnly=' + listOnly, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsItemisedOrders(deliveryDate, driverId, listOnly) {
  return new Promise(function(resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/orders/itemised?deliveryDate=' + deliveryDate + '&driverId=' + driverId, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsOrder(id) {
  return new Promise(function(resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/order/' + id, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsPickerCancel(itemId) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/order/item/' + itemId + '/picker/confirm/cancel', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function wmsMidStockCreate(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);

    axios.post(process.env.ROOT_API + 'wms/order/picker/midstock', JSON.stringify(form), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function wmsOrderItemMidStockCreate(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'wms/order/item/picker/midstock', JSON.stringify(form), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function wmsProductOrderItemsMidStockCreate(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'wms/order/items/picker/midstock', JSON.stringify(form), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function wmsOrderItemPickingCorrection(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);

    axios.post(process.env.ROOT_API + 'wms/order/item/picking/correction', JSON.stringify(form), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function wmsOrderItemMidStockChecked(form) {
  return new Promise(function(resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'wms/order/item/picker/check', JSON.stringify(form), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function wmsOrderItemMidStockUnchecked(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'wms/order/item/picker/uncheck', JSON.stringify(form), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsPickerConfirm(orderId, itemId, orderedAmount, pickerAmount) {
  return new Promise(function(resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/order/' + orderId + '/item/' + itemId + '/picker/confirm/' + orderedAmount + '/' + pickerAmount, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getWmsConfirmOrder(id) {
  return new Promise(function(resolve, reject) {
    console.log("get wms order");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/order/' + id + '/confirm', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function changeInventoryInventory(form) {
  return new Promise(function(resolve, reject) {
    console.log("uncheck " + form.orderItemId);
    axios.post(process.env.ROOT_API + 'wms/inventory/changelocation', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function moveInventoryInventory(form) {
  return new Promise(function(resolve, reject) {
    console.log("uncheck " + form.orderItemId);
    axios.post(process.env.ROOT_API + 'wms/inventory/move', JSON.stringify(form), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Inventory added");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getWmsDriverList(date) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'wms/delivery/drivers?deliveryDate=' + date, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/wms.js